import { wppColors } from '../../../App.styles';
import { translate } from '../../../i18n/translate';
import { ReactComponent as Calendar } from '../../images/calendar.svg';
import { ReactComponent as Reservation } from '../../images/reservation.svg';
import { ReactComponent as Home } from '../../images/home_icon.svg';
import { ReactComponent as Assets } from '../../images/assets_icon.svg';
import { ReactComponent as Reports } from '../../images/reports_icon.svg';
import { ReactComponent as Skills } from '../../images/skills_icon.svg';
import { ReactComponent as Desk } from '../../images/desk_icon.svg';
import { ReactComponent as MenuArrowCollapsed } from '../../images/menu-arrow-collapsed.svg';
import { ReactComponent as MenuArrowExpanded } from '../../images/menu-arrow-expanded.svg';

// `textKey` is a catalog key, resolved through `navItemText()` at render time
// so the nav follows the language the person picked.
//
// Each of these is its own app — Deskbooking, Skill Matrix, Control de
// Activos, Reportes — so `group` spaces them apart and `color` gives each one
// its own accent on the icon and the active underline.
//
// The palette is WPP's own: navy plus the orange ramp. It is a two-hue brand,
// so the apps read as one family at different weights rather than as four
// unrelated colours. Admin is deliberately grey — it is not an app.
export const BarData = [
  {
    textKey: 'nav.newReservation',
    hintKey: 'nav.hint.newReservation',
    path: '/',
    image: Reservation,
    group: 'deskbooking',
    color: wppColors.navy,
  },
  {
    textKey: 'nav.myReservations',
    hintKey: 'nav.hint.myReservations',
    path: '/myreservations',
    image: Calendar,
    group: 'deskbooking',
    color: wppColors.navy,
  },
];

// Deskbooking is one app with two everyday screens, so the bar shows it once
// and opens a menu with `BarData` inside, the same weight as every other app.
// `paths` also counts the routes reached from inside the app (meeting rooms,
// administrative booking) so the entry stays highlighted there.
export const deskbookingNav = {
  textKey: 'nav.deskbooking',
  image: Desk,
  group: 'deskbooking',
  color: wppColors.navy,
  paths: ['/', '/myreservations', '/meetingReservation', '/additionalWorkspace'],
};

export const specialUserBarData = [
  {
    textKey: 'nav.adminReservation',
    path: '/additionalWorkspace',
    image: Reservation,
    group: 'deskbooking',
    color: wppColors.navy,
  },
];

export const adminBarData = [
  {
    textKey: 'nav.admin',
    path: '/admin',
    image: Home,
    group: 'admin',
    color: '#525252',
  },
];

export const assetControlBarData = [
  {
    textKey: 'nav.assets',
    path: '/control-activos',
    image: Assets,
    group: 'assets',
    color: wppColors.orange800,
  },
];

export const reportsBarData = [
  {
    textKey: 'nav.reports',
    path: '/reportes',
    image: Reports,
    group: 'reports',
    color: wppColors.orange900,
  },
];

export const skillsBarData = [
  {
    textKey: 'nav.skills',
    path: '/skills',
    image: Skills,
    group: 'skills',
    color: wppColors.orange700,
  },
];

export const toggleNavBar = [
  {
    text: 'Open',
    path: '#',
    image: MenuArrowCollapsed,
  },
  {
    text: 'Close',
    path: '#',
    image: MenuArrowExpanded,
  }
]

/** Resolves a nav item's visible text in the active language. */
export const navItemText = (item) => translate(item.textKey);
